import { useState, useEffect } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { Tutorial } from "@/components/Tutorial";

/**
 * Renders the Tutorial component only when a regular user is logged in
 * and hasn't seen it yet (or explicitly opened it from MyAccount).
 *
 * Listens for the global event "tutorial:open" so any page (e.g. MyAccount
 * "Ver tutorial" button) can trigger it on demand.
 */
export const TutorialGate = () => {
  const { user } = useAuth();
  const [version, setVersion] = useState(0);
  const [force, setForce] = useState(false);

  useEffect(() => {
    const handler = () => {
      setForce(true);
      setVersion((v) => v + 1); // remount Tutorial so it reopens
    };
    window.addEventListener("tutorial:open", handler);
    return () => window.removeEventListener("tutorial:open", handler);
  }, []);

  if (!user || user.role === "admin") return null;
  return <Tutorial key={version} forceOpen={force} onClose={() => setForce(false)} />;
};
